export default __webpack_public_path__ + "static/media/middle.1447d385.svg";